import { render, staticRenderFns } from "./PeriodsItem.vue?vue&type=template&id=423a3dd2&scoped=true"
import script from "./PeriodsItem.vue?vue&type=script&lang=js"
export * from "./PeriodsItem.vue?vue&type=script&lang=js"
import style0 from "./PeriodsItem.vue?vue&type=style&index=0&id=423a3dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423a3dd2",
  null
  
)

export default component.exports